import currencies from "./data/currencies.json";

export const COMPLIANCES_WITH_DETAILS = {
  DBS: "DBS Check",
  HCPC: "HCPC/CCW/SSSC Check",
  QTS: "QTS/NCTL Qualification Check",
  REFERENCES: "Employment History Check",
  RTW: "Right to Work",
  BL: "Barred List Check",
  FTF: "Face-To-Face Interview",
  NIN: "Proof of National Insurance Number"
};

export const SORTING_DATA = [
  {
    default: true,
    label: "Date Created",
    value: "createdAt",
    options: [
      {
        value: "-",
        label: "Newest to oldest"
      },
      {
        value: "+",
        label: "Oldest to newest"
      }
    ]
  },
  {
    default: true,
    label: "Unsorted Applications",
    value: "applications_unsorted",
    options: [
      {
        value: "-",
        label: "High to low"
      },
      {
        value: "+",
        label: "Low to high"
      }
    ]
  },
  {
    default: true,
    label: "Released Applications",
    value: "applications_shortlisted",
    options: [
      {
        value: "-",
        label: "High to low"
      },
      {
        value: "+",
        label: "Low to high"
      }
    ]
  }
];

export const CONTRACT_TYPES = [
  {
    value: "permanent_full-time",
    label: "Permanent Full-Time"
  },
  {
    value: "temporary",
    label: "Temporary"
  },
  {
    value: "permanent_part-time",
    label: "Permanent Part-Time"
  }
];

export const BOOKING_OPTIONS = [
  {
    value: "requireQualifications",
    label: "Qualifications"
  },
  {
    value: "requireExperience",
    label: "Experience"
  },
  {
    value: "requireCv",
    label: "CV"
  }
];

export const CURRENCIES = currencies;
